import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { LoadingPane } from '~/components/loading-pane';
import { DeviceServicesPageDocument } from '../queries/Services.generated';
import { Layout, ServicesForm } from './components';

export const DeviceServices = () => {
  const params = useParams<{ deviceId: string }>();
  const deviceId = Number(params.deviceId);

  const { data, loading } = useQuery(DeviceServicesPageDocument, {
    variables: { deviceId },
  });

  const device = data?.device;

  return (
    <Layout>
      <LoadingPane in={loading && !data} size={40} thickness={4}>
        {device && <ServicesForm device={device} />}
      </LoadingPane>
    </Layout>
  );
};
